import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import App from './App.tsx'
import { AppDispatch } from './store'
import { fetchCurrentUser } from './redux/userSlice'

const isMockMode = import.meta.env.VITE_MOCK_STATE === 'true'

export default function Root() {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (!isMockMode) {
      dispatch(fetchCurrentUser())
    }
  }, [dispatch])

  return <App />
}
